import React, {ReactElement} from 'react';
import {Flex, Typography} from 'antd';
import {useSelector} from '../../../../../store/rootReducer';
import {authSelector} from '../../../../../store/auth';
import {getUserTypeName} from '../../../../../store/user/utils';
import styles from './AdminSpaceHeader.module.scss';

type AdminSpaceHeaderProps = {
  Search?: ReactElement<any>;
  label?: string;
};

const AdminSpaceHeader: React.FC<AdminSpaceHeaderProps> = ({Search, label}) => {
  const loggedInUser = useSelector((state) => authSelector(state).loggedInUser);

  return (
    <div className={`pageHeader ${styles.headerRoot}`}>
      <Flex justify="space-between" align="flex-start" gap={24} wrap className={styles.headerLayout}>
        <div className={styles.titleBlock}>
          <Typography.Title level={1} className={styles.title}>
            Admin Space
          </Typography.Title>
          <Typography.Paragraph className={styles.label}>
            {label || 'Enroll, activate and deactivate users'}
          </Typography.Paragraph>
        </div>

        <Flex align="center" gap={16} wrap className={styles.controlsSection}>
          {Search && <div className={styles.searchSlot}>{Search}</div>}
          {loggedInUser && (
            <div className={styles.roleBlock}>
              <Typography.Text className={styles.roleLabel}>My current role:</Typography.Text>
              <Typography.Text strong className={styles.roleValue}>
                {getUserTypeName(loggedInUser.userType)}
              </Typography.Text>
            </div>
          )}
        </Flex>
      </Flex>
    </div>
  );
};

export default AdminSpaceHeader;
